// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-item[data-v-651d5643]{margin-top:8px}.url-item[data-v-651d5643]{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
